import { analytics } from '../../../configs/firebase'
import { logEvent } from '@firebase/analytics'

const creditAnticipationAnalytics = {
  // Entrada na feature de antecipação
  trackView(): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_viewed', {
        event_category: 'credit_anticipation',
        event_label: 'viewed',
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Clique no checkbox "Quero garantir próximas consultas"
  trackOptIn(): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_opt_in', {
        event_category: 'credit_anticipation',
        event_label: 'opt_in',
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Desativação do checkbox
  trackOptOut(): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_opt_out', {
        event_category: 'credit_anticipation',
        event_label: 'opt_out',
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Seleção de mês futuro
  trackMonthSelected(month: string, year: number): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_month_selected', {
        event_category: 'credit_anticipation',
        event_label: 'month_selected',
        month,
        year,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Marcação de dias/horários
  trackSlotsSelected(date: string, time: string, slotsCount: number): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_slots_selected', {
        event_category: 'credit_anticipation',
        event_label: 'slots_selected',
        date,
        time,
        slots_count: slotsCount,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Alteração de slots
  trackSlotsUpdated(
    appointmentId: string,
    oldDate: string,
    newDate: string,
    oldTime: string,
    newTime: string
  ): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_slots_updated', {
        event_category: 'credit_anticipation',
        event_label: 'slots_updated',
        appointment_id: appointmentId,
        old_date: oldDate,
        new_date: newDate,
        old_time: oldTime,
        new_time: newTime,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Preview de agendamentos exibido
  trackPreviewViewed(appointmentsCount: number): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_preview_viewed', {
        event_category: 'credit_anticipation',
        event_label: 'preview_viewed',
        appointments_count: appointmentsCount,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Confirmação do agendamento
  trackConfirmed(selectedAppointmentsCount: number): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_confirmed', {
        event_category: 'credit_anticipation',
        event_label: 'confirmed',
        selected_appointments_count: selectedAppointmentsCount,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Antecipação concluída com sucesso
  trackSuccess(createdAppointmentsCount: number): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_success', {
        event_category: 'credit_anticipation',
        event_label: 'success',
        created_appointments_count: createdAppointmentsCount,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Falha ou bloqueio
  trackFailed(errorMessage: string, errorCode?: string): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_failed', {
        event_category: 'credit_anticipation',
        event_label: 'failed',
        error_message: errorMessage,
        error_code: errorCode || 'unknown',
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },

  // Cancelamento do fluxo
  trackAbandoned(step: string): void {
    if (analytics) {
      logEvent(analytics, 'credit_anticipation_abandoned', {
        event_category: 'credit_anticipation',
        event_label: 'abandoned',
        step,
      })
    } else {
      console.error('Firebase Analytics não está inicializado.')
    }
  },
}

export default creditAnticipationAnalytics
